/* eslint-disable import/no-cycle */
import { Stack, HStack, Box, Divider } from '@chakra-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import InputPreview from '../formInputs/InputPreview';
import FormLabelInput from '../formInputs/FormLabelInput';
import FormTextInput from '../formInputs/FormTextInput';
import MinMaxSelect from '../formInputs/MinMaxSelector';
import { useGetItemProperty } from '../hooks/useGetItemProperty';
import { FormBuilderComponentProps, FormFieldT } from '../types';

function TextFieldComponent({ fieldId, isAdvanced, labelRightRenderer }: Omit<FormBuilderComponentProps, 'path'>) {
  const { t } = useTranslation('hrFormTemplate');
  const isInfo = useGetItemProperty<FormFieldT['isInfo']>(fieldId, 'isInfo') ?? false;

  return (
    <Stack spacing={isInfo ? 0 : 2} sx={{ py: isInfo ? 2 : 0 }}>
      {!isInfo && (
        <HStack justify="space-between">
          <Box>
            <FormLabelInput fieldId={fieldId} isAdvanced={isAdvanced} />
          </Box>
          <HStack flexShrink={0} className="hide-in-drag-preview">
            <Divider orientation="vertical" />
            {labelRightRenderer}
          </HStack>
        </HStack>
      )}

      <FormTextInput fieldId={fieldId} isAdvanced={isAdvanced || false} />
      {!isInfo && (
        <InputPreview fieldId={fieldId} value={t('formBuilder.inputField')} rightContent={<MinMaxSelect fieldId={fieldId} />} />
      )}
    </Stack>
  );
}

export const TextField = React.memo(
  TextFieldComponent,
  (prev, next) =>
    // eslint-disable-next-line
    prev.fieldId === next.fieldId && prev.isAdvanced === next.isAdvanced && prev.labelRightRenderer === next.labelRightRenderer,
);
